export const iconFontAwesomeMediaplaybackRss = (
	<i className="fa-solid fa-rss"></i>
);
